module.exports = __webpack_public_path__ + "img/67.7.Chla.dea9bb42.png";